import { render, staticRenderFns } from "./SelfAssessModal.vue?vue&type=template&id=06fe72dc&scoped=true&"
import script from "./SelfAssessModal.vue?vue&type=script&lang=js&"
export * from "./SelfAssessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe72dc",
  null
  
)

export default component.exports